import { WebStorageStateStore } from 'oidc-client';
import { appConfig } from './app';

export const oidcConfig: Oidc.UserManagerSettings = {
  accessTokenExpiringNotificationTime: 300,
  authority:
    process.env.NODE_ENV === 'development'
      ? 'http://localhost:6050'
      : 'https://identity.experthire.fr',
  automaticSilentRenew: true,
  client_id:
    process.env.NODE_ENV === 'development'
      ? 'expert-hire-admin-test'
      : 'ZXhwZXJ0LWhpcmUtYWRtaW4tcHJvZHVjdGlvbg==',
  post_logout_redirect_uri: appConfig.APP_URL,
  redirect_uri: `${appConfig.APP_URL}/signin-oidc`,
  response_type: 'code',
  scope: 'openid profile email experthire.api role',
  silent_redirect_uri: `${appConfig.APP_URL}/silent-renew`,
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
};
